import { css } from 'styled-components';
import { fontBold } from './cssGlobalVariables';

export const titleStyles = css`
    color: var(--color-dark-body);
    font-size: 32px;
    line-height: 40px;
    font-family: ${fontBold};
    text-align: center;
`;

export const subtitleStyles = css`
    color: var(--color-dark-body);
    font-size: 20px;
    line-height: 24px;
    font-family: ${fontBold};
    padding-bottom: 16px;
`;

export const visuallyHidden = css`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;
